import { useMemo } from "react";
import { useEnduserStore } from "../store/hooks";
import { useOrganization } from "../../shared/store/organizationStore";
import { usePortalSchema } from "../../shared/store/portalSchemaStore";
import { usePortalSchemaContext } from "../../shared/context/PortalSchemaContext";
import type { TemplateContext } from "@tellescope/utils";

/**
 * Hook to build the template context from available data sources.
 * Follows the same pattern as useVisibilityContext.
 */
export function useTemplateContext(): TemplateContext {
  const enduser = useEnduserStore((state) => state.currentEnduser);
  const organization = useOrganization();

  // Check for context override first (admin preview), then fall back to global store
  const contextSchema = usePortalSchemaContext();
  const storeSchema = usePortalSchema();
  const schema = contextSchema ?? storeSchema;

  // Convert snippets array to key-value map
  const snippets = useMemo(() => {
    const map: Record<string, string> = {};
    for (const s of schema?.snippets ?? []) {
      map[s.key] = s.value;
    }
    return map;
  }, [schema?.snippets]);

  return useMemo(
    () => ({
      enduser,
      organization,
      snippets,
    }),
    [enduser, organization, snippets]
  );
}
